export enum RoutePathsE {
  TICKETS_PAGE = '/tickets',
  LOGIN_PAGE = '/login',
  PROFILE_PAGE = '/profile',
  RELEASES_PAGE = '/releases',
}
